export default {
  setFoodMerchantCategories(state, payload) {
    state.foodMerchantCategories = payload;
  },
};
